export enum CompanyTypeEnum {
  ONLY = 'ONLY',
  GROUP = 'GROUP',
  CHILD = 'CHILD',
}
